// src/app/auth/admin.guard.ts
import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { from, Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { fetchAuthSession } from 'aws-amplify/auth';
import { NO_ACCESS_HOME } from '../shared/utils/auth-groups.util';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
  private router = inject(Router);

  canActivate(): Observable<boolean | UrlTree> {
    return from(fetchAuthSession()).pipe(
      map(session => {
        const idToken = session?.tokens?.idToken?.toString();
        if (!idToken) {
          return this.router.createUrlTree(['/login']);
        }
        const payload = this.decodeJwt(idToken);
        const groups: string[] = payload['cognito:groups'] || [];
        return groups.includes('ADMIN')
          ? true
          : this.router.createUrlTree([NO_ACCESS_HOME]);
      }),
      catchError(() => of(this.router.createUrlTree(['/login'])))
    );
  }

  /**
   * Copie locale conservée volontairement : le reste de l'application décode le
   * token via `shared/utils/auth-groups.util.ts`. Cette garde est donc le seul
   * fichier qui ne suivra pas un changement de décodage — voir la section
   * correspondante de `knowledge/gestionnaire/espace_gestionnaire.md`.
   */
  private decodeJwt(token: string): any {
    try {
      const [, payloadBase64] = token.split('.');
      const json = atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/'));
      return JSON.parse(json);
    } catch {
      return {};
    }
  }
}
